/* eslint-disable react-hooks/rules-of-hooks */
import { useState } from 'react';
import { isWeb } from '@global/screens';

const tableApi = (countRequest, listRequest, countElastic, listElastic) => {
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  const request = async (params, id = null, useElastic = false) => {
    try {
      setLoading(true);
      let countResponse = null;
      let allData = [];
      if (params.skip === 0) {
        if (useElastic && countElastic) {
          countResponse = await countElastic({ params }, id);
        } else {
          countResponse = await countRequest({ params }, id);
        }
      }
      if (params.skip > 0 && !isWeb) {
        setLoadingMore(true);
      }
      if (
        (countResponse &&
          countResponse.status === 200 &&
          countResponse.data?.data) ||
        params.skip > 0
      ) {
        if (params.skip === 0) {
          setCount(countResponse.data.data);
        }
        let response = null;
        if (useElastic && listElastic) {
          response = await listElastic({ params }, id);
        } else {
          response = await listRequest({ params }, id);
        }
        allData = response.data.data;
        if (params.skip > 0 && !isWeb) {
          allData = [...data, ...allData];
        }
        setData(allData);
      }
      setLoading(false);
      setLoadingMore(false);
      setError(false);
      return allData;
    } catch (e) {
      setCount(0);
      setData([]);
      setError(true);
      setLoading(false);
      setLoadingMore(false);
      return false;
    }
  };

  const reset = () => {
    setCount(0);
    setData([]);
    setError(false);
    setLoading(false);
    setLoadingMore(false);
  };

  return {
    data,
    count,
    error,
    loading,
    loadingLoadMore: loadingMore,
    loadingMore,
    request,
    reset,
  };
};

export default tableApi;
